// @flow
import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Base, Badge, Text } from '@gandi/ui';

import DetailRow from './DetailRow';
import type { Props as DetailRowProps } from './DetailRow';

type Props = {
  label: string,
  detail?: DetailRowProps['detail'],
  price: DetailRowProps['price'],
};

export function DiscountRow({
  label,
  detail,
  price,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  const labelRow = (
    <Base flex gap="xxsmall" flexAlignItemsCenter>
      <Badge intent="promotional">{__('Promo')}</Badge>
      <Text>{label}</Text>
    </Base>
  );

  const negativePrice =
    typeof price === 'number' && price > 0 ? -1 * price : price;

  return <DetailRow label={labelRow} detail={detail} price={negativePrice} />;
}
